import { render, staticRenderFns } from "./BaseModalComponent.vue?vue&type=template&id=47f85d4b"
import script from "./BaseModalComponent.vue?vue&type=script&lang=js"
export * from "./BaseModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports